<div class="codes-reel-container">
  <div class="filter-container">
    <button
      type="button"
      class="filter-fab"
      [class.filter-fab--hidden]="open()"
      (click)="open.set(true)"
      aria-label="Filtry"
      aria-haspopup="dialog"
    >
      <svg
        viewBox="0 0 24 24"
        class="filter-fab__icon"
        focusable="false"
        aria-hidden="true"
      >
        <path d="M3 6h18M7 11h10M10 16h4" />
      </svg>
    </button>

    <app-category-filter
      [name]="'Kody rabatowe'"
      [data]="filterDataForFocusedView()"
      [open]="open()"
      (toggled)="open.set($event)"
      (selected)="filterAuctions($event.id)"
    >
    </app-category-filter>
  </div>

  @if (codes().length > 0) {

  <app-codes-roller [items]="codes()" (reserve)="reserveCode($event)" />
  }
   @else {
  <p class="m-0 empty">Brak wyników.</p>
  }
</div>

